import { Currency } from "../Currency.js";
import { Locale, type LocalizedString } from "../Locale.js";

export const currencyNameMap: Record<Currency, LocalizedString> = {
	[Currency.CZK]: {
		[Locale.en]: "Czech Koruna",
		[Locale.cs]: "Česká koruna",
	},
	[Currency.EUR]: {
		[Locale.en]: "Euro",
		[Locale.cs]: "Euro",
	},
	[Currency.PLN]: {
		[Locale.en]: "Polish Złoty",
		[Locale.cs]: "Polský zlotý",
	},
};
